import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

import { useProfile } from "../../../api/hooks/profile";

function BasicData({ onEditData, requiredData }) {
  const { profile, isLoading } = useProfile();
  const {
    givenName: name,
    familyName: lastname,
    email: mail,

    phone,
    office = {},
    bankData = {},
  } = profile || {};
  // name: values.name,
  //       businessName: values.businessName,
  //       representative: values.representative,
  //       companyEmail: values.companyEmail,
  //       fiscalDirection: values.fiscalDirection,
  //       postalCode: values.postalCode,
  //       companyPhone: values.companyPhone,

  const {
    name: businessName,
    businessName: normalName,
    representative: representative,
    email: companyEmail,
    address: fiscalDirection,
    zipCode: postalCode,
    phone: companyPhone,
  } = office;
  const { name: bankName, standarizedBankCode: clabe } = bankData;

  return (
    <div className="Settings__Box">
      {requiredData === "personal" ? (
        <>
          <h2 className="font-weight-bold">Información</h2>
          <FontAwesomeIcon
            icon={faPen}
            color="#9ea0a5"
            className="EditSettingsButton"
            size="2.4rem"
            onClick={onEditData}
          />
          <div className="settingsBasicData">
            <table style={{ width: "100%" }}>
              <tr>
                <th>Nombre</th>
                <th>Apellidos</th>
              </tr>
              <tr>
                <td>{name}</td>
                <td>{lastname}</td>
              </tr>
              <tr style={{ height: "10px" }}></tr>
            </table>
            <table style={{ width: "100%" }}>
              <tr style={{ height: "10px" }}></tr>
              <tr>
                <th>Correo:</th>
                <th>Número Celular:</th>
              </tr>
              <tr>
                <td>{mail}</td>
                <td>{phone}</td>
              </tr>
              <tr style={{ height: "10px" }}></tr>
            </table>
          </div>
          <div className="settingsBasicData" style={{ marginTop: "50px" }}>
            <h2 className="font-weight-bold">Detalles de Pago</h2>
            <table style={{ width: "100%" }}>
              <tr>
                <th>Tipo de Pago</th>
              </tr>
              <tr>
                <td>{"Transferenica Bancaria"}</td>
              </tr>
              <tr>
                <th>Nombre del Banco</th>
                <th>CLABE</th>
              </tr>
              <tr>
                <td>{bankName}</td>
                <td>{clabe}</td>
              </tr>
              <tr style={{ height: "10px" }}></tr>
            </table>
          </div>
        </>
      ) : (
        <>
          <h2 className="font-weight-bold">Información</h2>
          <FontAwesomeIcon
            icon={faPen}
            color="#9ea0a5"
            className="EditSettingsButton"
            size="2.4rem"
            onClick={onEditData}
          />
          <div className="settingsBasicData">
            <table style={{ width: "100%" }}>
              <tr>
                <th>Nombre</th>
                <th>Razón Social</th>
              </tr>
              <tr>
                <td>{normalName}</td>
                <td>{businessName}</td>
              </tr>
              <tr style={{ height: "10px" }}></tr>
            </table>
            <table style={{ width: "100%" }}>
              <tr style={{ height: "10px" }}></tr>
              <tr>
                <th>Representante Legal:</th>
                <th>Telefono:</th>
              </tr>
              <tr>
                <td>{representative}</td>
                <td>{companyPhone}</td>
              </tr>
              <tr style={{ height: "10px" }}></tr>
            </table>
            <table style={{ width: "100%" }}>
              <tr style={{ height: "10px" }}></tr>
              <tr>
                <th>Código Postal:</th>
                <th>E-Mail Empresa:</th>
              </tr>
              <tr>
                <td>{postalCode}</td>
                <td>{companyEmail}</td>
              </tr>
              <tr style={{ height: "10px" }}></tr>
            </table>
            <table style={{ width: "100%" }}>
              <tr style={{ height: "10px" }}></tr>
              <tr>
                <th>Dirección Fiscal:</th>
              </tr>
              <tr>
                <td>{fiscalDirection}</td>
              </tr>
              <tr style={{ height: "10px" }}></tr>
            </table>
          </div>{" "}
        </>
      )}
    </div>
  );
}

export default BasicData;
